import React, {useState} from "react";
import { TextField, Checkbox, FormControlLabel, Grid, Typography, Box, FormControl, FormLabel, RadioGroup, Radio, Button, FormHelperText } from "@mui/material";
import PdfModalViewer from "./PdfModalViewer";

const Comp1Sub = ({ formData, setFormData, mypageData, sameAsExhibitor, setSameAsExhibitor, fieldsDisabled, setFieldsDisabled, submitErrors, corrections, changeModalOpen, handleCorrectionChange, exhibitorId, exhibitors }) => {
  const handleChange = (field) => (e) => {
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSameAsExhibitor = (value) => {
    setSameAsExhibitor(value);

    if (value === "same") {
      // 出展者情報コピー
      setFormData((prev) => ({
        ...prev,
        user_1_name: mypageData.user_name || "",
        user_1_department: mypageData.department || "",
        user_1_phone: mypageData.phone_number || "",
        user_1_tel: mypageData.tel_number || "",
      }));
      setFieldsDisabled(true);
    } else if (value === "different") {
      // フィールドを空にする
      setFormData((prev) => ({
        ...prev,
        user_1_name: "",
        user_1_department: "",
        user_1_phone: "",
        user_1_tel: "",
      }));
      setFieldsDisabled(false);
    }
  };

  const [open , setOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  console.log(mypageData)
  return (
    <Box sx={{ p:{xs: 0, md: 2} }}>
    {!!changeModalOpen &&(
      <FormControlLabel
        control={
          <Checkbox
            checked={corrections.r1[0].manager_info}
            onChange={handleCorrectionChange('r1', 'manager_info')}
            sx={{
              color: 'red', // 未チェック時の枠の色
              '&.Mui-checked': {
                color: 'red', // チェック時の色
              },
            }}
          />
        }
        label="責任者情報"
      />
    )}
      <Typography variant="h6" gutterBottom className="f-16">責任者情報</Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="氏名" value={formData.manager_name} onChange={handleChange("manager_name")} error={!!submitErrors.manager_name} helperText={submitErrors.manager_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
        <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="部署" value={formData.manager_department} onChange={handleChange("manager_department")} error={!!submitErrors.manager_name} helperText={submitErrors.manager_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
        <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="会社電話番号" value={formData.manager_phone} onChange={handleChange("manager_phone")} error={!!submitErrors.manager_name} helperText={submitErrors.manager_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
        <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="携帯電話番号" value={formData.manager_tel} onChange={handleChange("manager_tel")} error={!!submitErrors.manager_name} helperText={submitErrors.manager_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
      </Grid>
      <Typography color="error" className="info">※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>

      
      {!!changeModalOpen &&(
        <FormControlLabel
          control={
            <Checkbox
              checked={corrections.r1[0].user_1_info}
              onChange={handleCorrectionChange('r1', 'user_1_info')}
              sx={{
          color: 'red', // 未チェック時の枠の色
          '&.Mui-checked': {
            color: 'red', // チェック時の色
          },
        }}
            />
          }
          label="担当者情報"
        />
      )}
      <Typography variant="h6" sx={{ mt: 4 }} className="f-16">担当者情報</Typography>
      <Typography color="error" className="info">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
      <FormControl component="fieldset" sx={{ mt: 2 }}>
        <FormLabel component="legend" className="info">出展申込時の担当者と</FormLabel>
        <RadioGroup
          row
          value={sameAsExhibitor}
          onChange={(e) => handleSameAsExhibitor(e.target.value)}
        >
          <FormControlLabel value="same" control={<Radio />} label="同じ" />
          <FormControlLabel value="different" control={<Radio />} label="異なる" />
        </RadioGroup>
      </FormControl>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="氏名" value={formData.user_1_name} onChange={handleChange("user_1_name")} disabled={fieldsDisabled} error={!!submitErrors.user_1_name} helperText={submitErrors.user_1_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
        <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="部署" value={formData.user_1_department} onChange={handleChange("user_1_department")} disabled={fieldsDisabled} error={!!submitErrors.user_1_department} helperText={submitErrors.user_1_department} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
        <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="会社電話番号" value={formData.user_1_phone} onChange={handleChange("user_1_phone")} disabled={fieldsDisabled} error={!!submitErrors.user_1_phone} helperText={submitErrors.user_1_phone} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
        <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="携帯電話番号" value={formData.user_1_tel} onChange={handleChange("user_1_tel")} disabled={fieldsDisabled} error={!!submitErrors.user_1_tel} helperText={submitErrors.user_1_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
      </Grid>
      <Typography color="error" className="info">※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>

      <Box sx={{ mt: 4 }}>
        <Box>
          <Button variant="outlined" onClick={() => setOpen(true)} className="info">出展の手引きを表示する</Button>
        </Box>
        <PdfModalViewer
          filePath="/出展規定.pdf"
          isOpen={open}
          onClose={() => setOpen(false)}
          startPage={1}
          endPage={36}
        />
        <FormControlLabel
          control={<Checkbox checked={formData.pledge} onChange={handleChange("pledge")} sx={{color: 'red'}} />}
          label="出展規定及び出展の手引きを遵守し、出展することを誓約します。"
        />
        <Typography color="error" className="info">※チェックいただくと、上記に同意したとさせていただきます。（チェック必須）</Typography>
      </Box>
      <Box sx={{ mt: 4 }}>
        {((mypageData?.user_id === 0) || exhibitors?.find(ex => ex.exhibitor_id === exhibitorId)?.user_id === 0) && (
          <>
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.panel_pledge}
                onChange={handleChange("panel_pledge")}
                sx={{ color: 'red' }}
              />
            }
            label="システムパネル・突出し社名板を追加希望する。"
          />
          <Typography color="error" className="info">
            ※基礎小間出展限定<br />
          　土間小間でで追加希望の場合はレンタル備品よりシステムパネルをお申込みください。
          </Typography>
          {formData?.panel_pledge && (
          <>
          <TextField
            fullWidth
            multiline
            rows={4}
            label="突出し社名板用質問欄"
            value={formData.panel_question}
            onChange={handleChange("panel_question")}
          />
          </>
          )}
          <Box>
            <FormControl
              component="fieldset"
              fullWidth
              sx={{ mt: 2 }}
              error={!!submitErrors?.panel_plan} // ← エラー有無を反映
            >
              <FormLabel component="legend" className="f-16">社名板の表記方法</FormLabel>
              <Typography color="error" className="info">
                ※「ブース平面図」より、配置図をアップロードしてください。
              </Typography>

              <RadioGroup
                name="panel_plan"
                value={formData.panel_plan || ""}
                onChange={handleChange("panel_plan")}
              >
                <Grid container spacing={2}>
                  <Grid size={6}>
                    <FormControlLabel
                      value="親出展者名のみ表記"
                      control={<Radio />}
                      label="親出展者名のみ表記"
                    />
                    <Box sx={{ mt: 1 }}>
                      <img src="/parent_only.png" alt="親出展者名のみ表記" width="250px" />
                    </Box>
                  </Grid>

                  <Grid size={6}>
                    <FormControlLabel
                      value="子出展者名メインで表記"
                      control={<Radio />}
                      label="子出展者名メインで表記"
                    />
                    <Box sx={{ mt: 1 }}>
                      <img src="/child_only.png" alt="子出展者名メインで表記" width="250px" />
                    </Box>
                  </Grid>

                  <Grid size={6}>
                    <FormControlLabel
                      value="親・子出展者名を並列で表記"
                      control={<Radio />}
                      label="親・子出展者名を並列で表記"
                    />
                    <Box sx={{ mt: 1 }}>
                      <img src="/parallel.png" alt="親・子出展者名を並列で表記" width="250px" />
                    </Box>
                  </Grid>

                  <Grid size={6}>
                    <FormControlLabel
                      value="グループ表記"
                      control={<Radio />}
                      label="グループ表記"
                    />
                    <FormHelperText className="info">
                      ※出展者マイページでグループ表記を選択した場合のみ選択してください。
                    </FormHelperText>
                    <Box sx={{ mt: 1 }}>
                      <img src="/group.png" alt="グループ表記" width="250px" />
                    </Box>
                  </Grid>
                </Grid>
              </RadioGroup>

              {/* 👇 ここでエラーメッセージを表示 */}
              {submitErrors?.panel_plan && (
                <FormHelperText>{submitErrors.panel_plan}</FormHelperText>
              )}
            </FormControl>
          </Box>
          </>
        )}
      </Box>

      <Typography variant="h6" gutterBottom className="f-16">委託会社情報</Typography>
      <Typography color="error" className="info">本展示会の協力会社以外に自社で依頼されている委託会社が作業する場合はチェックボックスを選択の上、委託会社情報をご入力ください。</Typography>
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.has_package_company}
            onChange={(e) => {
              const checked = e.target.checked;
              setFormData(prev => ({
                ...prev,
                has_package_company: checked,
                ...(checked ? {} : {
                  package_company_name: null,
                  package_company_tel: null,
                  package_phone_number: null,
                  package_company_address: null,
                  package_company_zip: null,
                  package_company_fax: null,
                  package_name: null,
                })
              }));
            }}
          />
        }
        label="装飾委託会社あり"
      />

      {formData.has_package_company && (
        <>
        {!!changeModalOpen &&(
          <FormControlLabel
            control={
              <Checkbox
                checked={corrections.r1[0].package_info}
                onChange={handleCorrectionChange('r1', 'package_info')}
                sx={{
          color: 'red', // 未チェック時の枠の色
          '&.Mui-checked': {
            color: 'red', // チェック時の色
          },
        }}
              />
            }
            label="装飾委託会社情報"
          />
        )}
        <Grid container spacing={2}>
          <Grid size={12}><TextField fullWidth label="会社名" value={formData.package_company_name || ""} onChange={handleChange("package_company_name")} error={!!submitErrors.package_company_name} helperText={submitErrors.package_company_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="会社電話番号" value={formData.package_company_tel || ""} onChange={handleChange("package_company_tel")} error={!!submitErrors.package_company_tel} helperText={submitErrors.package_company_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="携帯電話番号" value={formData.package_phone_number || ""} onChange={handleChange("package_phone_number")} error={!!submitErrors.package_phone_number} helperText={submitErrors.package_phone_number} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="郵便番号" value={formData.package_company_zip || ""} onChange={handleChange("package_company_zip")} error={!!submitErrors.package_company_zip} helperText={submitErrors.package_company_zip} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
          <Grid size={12}><TextField fullWidth label="住所" value={formData.package_company_address || ""} onChange={handleChange("package_company_address")} error={!!submitErrors.package_company_address} helperText={submitErrors.package_company_address} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField sx={{ "& .MuiOutlinedInput-root": {"& fieldset": {borderColor: "#ccc",}} }} fullWidth label="FAX番号" value={formData.package_company_fax || ""} onChange={handleChange("package_company_fax")} /></Grid>
          <Grid size={12}><TextField fullWidth label="担当者名" value={formData.package_name || ""} onChange={handleChange("package_name")} error={!!submitErrors.package_name} helperText={submitErrors.package_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
        </Grid>
        </>
      )}
      {/* 以下、elec / infla / cargo もパッケージ会社と同じフォーマットで */}
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.has_elec_company}
            onChange={(e) => {
              const checked = e.target.checked;
              setFormData(prev => ({
                ...prev,
                has_elec_company: checked,
                ...(checked ? {} : {
                  elec_company_name: null,
                  elec_company_tel: null,
                  elec_phone_number: null,
                  elec_company_address: null,
                  elec_company_zip: null,
                  elec_company_fax: null,
                  elec_name: null,
                })
              }));
            }}
          />
        }
        label="電気工事委託会社あり"
      />

      {formData.has_elec_company && (
        <>
        {!!changeModalOpen &&(
          <FormControlLabel
            control={
              <Checkbox
                checked={corrections.r1[0].elec_info}
                onChange={handleCorrectionChange('r1', 'elec_info')}
                sx={{
          color: 'red', // 未チェック時の枠の色
          '&.Mui-checked': {
            color: 'red', // チェック時の色
          },
        }}
              />
            }
            label="電気工事委託会社情報"
          />
        )}
        <Grid container spacing={2}>
          <Grid size={12}><TextField fullWidth label="会社名" value={formData.elec_company_name || ""} onChange={handleChange("elec_company_name")} error={!!submitErrors.elec_company_name} helperText={submitErrors.elec_company_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="会社電話番号" value={formData.elec_company_tel || ""} onChange={handleChange("elec_company_tel")} error={!!submitErrors.elec_company_tel} helperText={submitErrors.elec_company_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="携帯電話番号" value={formData.elec_phone_number || ""} onChange={handleChange("elec_phone_number")} error={!!submitErrors.elec_phone_number} helperText={submitErrors.elec_phone_number} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="郵便番号" value={formData.elec_company_zip || ""} onChange={handleChange("elec_company_zip")} error={!!submitErrors.elec_company_zip} helperText={submitErrors.elec_company_zip} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
          <Grid size={12}><TextField fullWidth label="住所" value={formData.elec_company_address || ""} onChange={handleChange("elec_company_address")} error={!!submitErrors.elec_company_address} helperText={submitErrors.elec_company_address} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField sx={{ "& .MuiOutlinedInput-root": {"& fieldset": {borderColor: "#ccc",}} }} fullWidth label="FAX番号" value={formData.elec_company_fax || ""} onChange={handleChange("elec_company_fax")} /></Grid>
          <Grid size={12}><TextField fullWidth label="担当者名" value={formData.elec_name || ""} onChange={handleChange("elec_name")} error={!!submitErrors.elec_name} helperText={submitErrors.elec_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
        </Grid>
        </>
      )}

      {/* infla、cargo も同様にここに並べていく */}
      {/* <FormControlLabel
        control={
          <Checkbox
            checked={formData.has_infla_company}
            onChange={(e) => {
              const checked = e.target.checked;
              setFormData(prev => ({
                ...prev,
                has_infla_company: checked,
                ...(checked ? {} : {
                  infla_company_name: null,
                  infla_company_tel: null,
                  infla_phone_number: null,
                  infla_company_address: null,
                  infla_company_zip: null,
                  infla_company_fax: null,
                  infla_name: null,
                })
              }));
            }}
          />
        }
        label="給排水・エア・ガス工事委託会社あり"
      />

      {formData.has_infla_company && (
        <>
        {!!changeModalOpen &&(
          <FormControlLabel
            control={
              <Checkbox
                checked={corrections.r1[0].water_info}
                onChange={handleCorrectionChange('r1', 'water_info')}
                sx={{
          color: 'red', // 未チェック時の枠の色
          '&.Mui-checked': {
            color: 'red', // チェック時の色
          },
        }}
              />
            }
            label="給排水・エア・ガス委託会社情報"
          />
        )}
    
        <Grid container spacing={2}>
          <Grid size={12}><TextField fullWidth label="会社名" value={formData.infla_company_name || ""} onChange={handleChange("infla_company_name")} error={!!submitErrors.infla_company_name} helperText={submitErrors.infla_company_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="会社電話番号" value={formData.infla_company_tel || ""} onChange={handleChange("infla_company_tel")} error={!!submitErrors.infla_company_tel} helperText={submitErrors.infla_company_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="携帯電話番号" value={formData.infla_phone_number || ""} onChange={handleChange("infla_phone_number")} error={!!submitErrors.infla_phone_number} helperText={submitErrors.infla_phone_number} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="郵便番号" value={formData.infla_company_zip || ""} onChange={handleChange("infla_company_zip")} error={!!submitErrors.infla_company_zip} helperText={submitErrors.infla_company_zip} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
          <Grid size={12}><TextField fullWidth label="住所" value={formData.infla_company_address || ""} onChange={handleChange("infla_company_address")} error={!!submitErrors.infla_company_address} helperText={submitErrors.infla_company_address} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField sx={{ "& .MuiOutlinedInput-root": {"& fieldset": {borderColor: "#ccc",}} }} fullWidth label="FAX番号" value={formData.infla_company_fax || ""} onChange={handleChange("infla_company_fax")} /></Grid>
          <Grid size={12}><TextField fullWidth label="担当者名" value={formData.infla_name || ""} onChange={handleChange("infla_name")} error={!!submitErrors.infla_name} helperText={submitErrors.infla_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
        </Grid>
        </>
      )} */}
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.has_cargo_company}
            onChange={(e) => {
              const checked = e.target.checked;
              setFormData(prev => ({
                ...prev,
                has_cargo_company: checked,
                ...(checked ? {} : {
                  cargo_company_name: null,
                  cargo_company_tel: null,
                  cargo_phone_number: null,
                  cargo_company_address: null,
                  cargo_company_zip: null,
                  cargo_company_fax: null,
                  cargo_name: null,
                })
              }));
            }}
          />
        }
        label="荷役委託会社あり"
      />

      {formData.has_cargo_company && (
        <>
        {!!changeModalOpen &&(
          <FormControlLabel
            control={
              <Checkbox
                checked={corrections.r1[0].cargo_info}
                onChange={handleCorrectionChange('r1', 'cargo_info')}
                sx={{
          color: 'red', // 未チェック時の枠の色
          '&.Mui-checked': {
            color: 'red', // チェック時の色
          },
        }}
              />
            }
            label="荷役委託会社情報"
          />
        )}
        <Grid container spacing={2}>
          <Grid size={12}><TextField fullWidth label="会社名" value={formData.cargo_company_name || ""} onChange={handleChange("cargo_company_name")} error={!!submitErrors.cargo_company_name} helperText={submitErrors.cargo_company_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="会社電話番号" value={formData.cargo_company_tel || ""} onChange={handleChange("cargo_company_tel")} error={!!submitErrors.cargo_company_tel} helperText={submitErrors.cargo_company_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="携帯電話番号" value={formData.cargo_phone_number || ""} onChange={handleChange("cargo_phone_number")} error={!!submitErrors.cargo_phone_number} helperText={submitErrors.cargo_phone_number} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="郵便番号" value={formData.cargo_company_zip || ""} onChange={handleChange("cargo_company_zip")} error={!!submitErrors.cargo_company_zip} helperText={submitErrors.cargo_company_zip} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
          <Grid size={12}><TextField fullWidth label="住所" value={formData.cargo_company_address || ""} onChange={handleChange("cargo_company_address")} error={!!submitErrors.cargo_company_address} helperText={submitErrors.cargo_company_address} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
          <Grid size={{ xs: 12, sm: 6 }}><TextField sx={{ "& .MuiOutlinedInput-root": {"& fieldset": {borderColor: "#ccc",}} }} fullWidth label="FAX番号" value={formData.cargo_company_fax || ""} onChange={handleChange("cargo_company_fax")} /></Grid>
          <Grid size={12}><TextField fullWidth label="担当者名" value={formData.cargo_name || ""} onChange={handleChange("cargo_name")} error={!!submitErrors.cargo_name} helperText={submitErrors.cargo_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
        </Grid>
        </>
      )}

      <Typography variant="h6" sx={{ mt: 4 }} className="f-16">備考欄</Typography>
      <Typography color="error" className="info">※出展責任者について補足事項等がある場合はコチラにご入力ください。</Typography>
      <TextField
        fullWidth
        multiline
        rows={4}
        label="備考"
        value={formData.alfa_text}
        onChange={handleChange("alfa_text")}
      />
    </Box>
  );
};

export default Comp1Sub;